/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

/**
 *  Tv - channels plugin or system module implementation
 *  Same interface with tv provider from embedded magcore
 */

'use strict';

var Emitter                 = require('cjs-emitter'),
    Channel                 = require('./channel.class'),
    Epg                     = require('./epg.class'),
    instanceList            = [],
    currentChannelList      = [],
    request                 = window.core.stalker.request,

    // count of channels to get per request to init provider
    INIT_CHANNELS_LIMIT     = 500,
    UPDATE_CHANNELS_TIMEOUT = 60000 * 3,    // every 3 minutes update channels
    UPDATE_INTERVALS_DELAY  = 15000,         // delay between intervals
    EMPTY_INTERVAL_COUNT    = 10,

    emptyCounter            = {
        addCount: 0,
        updateCount: 0,
        deleteCount: 0
    },
    tempChannelsData        = [],
    intervals               = {},
    LAST_CHANNELS_ADD,
    LAST_CHANNELS_UPDATE,
    LAST_CHANNELS_DELETE,
    // when collecting channels in parts save channels in tmp array
    totalChannels;


window.core.backend.addListener('message', function ( message ) {
    switch ( message.type ) {
        case 'update_subscription':
            instanceList.forEach(function ( instance ) {
                getChannels({update: true});
            });
            break;
    }
});


intervals.addChannelsInterval = setInterval(addChannelsHandler, UPDATE_CHANNELS_TIMEOUT);

setTimeout(function() {
    intervals.deleteChannelsInterval = setInterval(deleteChannelsHandler, UPDATE_CHANNELS_TIMEOUT);
}, UPDATE_INTERVALS_DELAY);

setTimeout(function() {
    intervals.updateChannelsInterval = setInterval(updateChannelsHandler, UPDATE_CHANNELS_TIMEOUT);
}, UPDATE_INTERVALS_DELAY * 2);


function addChannelsHandler () {
    var url;

    if ( !instanceList.length && emptyCounter.addCount < EMPTY_INTERVAL_COUNT ) {
        emptyCounter.addCount++;
        return;
    }
    url = 'tv-channels/added?from=' + LAST_CHANNELS_ADD + '&t=' + +new Date();
    emptyCounter.addCount = 0;
    request(url, {
        onload: function ( error, response ) {
            if ( !error && response ) {
                LAST_CHANNELS_ADD = response.timestamp;
                if ( response.data.length ) {

                    response.data = response.data.map(function ( object ) {
                        return new Channel(object);
                    });
                    currentChannelList = currentChannelList.concat(response.data);
                    instanceList.forEach(function( provider ) {
                        provider.emit('channels:add', {data:response.data});
                    });
                }
            }
        }
    });
}

function deleteChannelsHandler () {
    if ( !instanceList.length && emptyCounter.deleteCount < EMPTY_INTERVAL_COUNT ) {
        emptyCounter.deleteCount++;
        return;
    }
    emptyCounter.deleteCount = 0;
    request('tv-channels/deleted?from=' + LAST_CHANNELS_DELETE + '&t=' + +new Date(), {
        onload: function ( error, response ) {
            if ( !error && response ) {
                LAST_CHANNELS_DELETE = response.timestamp;
                if ( response.data.length ) {
                    currentChannelList = currentChannelList.filter(function (ch) {
                        return (response.data.indexOf(ch.id) < 0);
                    });
                    instanceList.forEach(function( provider ) {
                        provider.emit('channels:delete', {data: response.data});
                    });
                }
            }
        }
    });
}

function updateChannelsHandler () {
    if ( !instanceList.length && emptyCounter.updateCount < EMPTY_INTERVAL_COUNT ) {
        emptyCounter.updateCount++;
        return;
    }
    emptyCounter.updateCount = 0;
    request('tv-channels/modified?from=' + LAST_CHANNELS_UPDATE + '&t=' + +new Date(), {
        onload: function ( error, response ) {
            var hash = {},
                index;

            if ( !error && response ) {
                LAST_CHANNELS_UPDATE = response.timestamp;
                if ( response.data.length ) {

                    response.data.forEach(function ( updated ) {
                        hash[updated.id] = new Channel(updated);
                    });

                    for ( index = 0; index < provider.data.length; index++ ) {
                        if ( hash[currentChannelList[index].id] ) {
                            currentChannelList[index] = hash[currentChannelList[index].id];
                        }
                    }

                    instanceList.forEach(function ( provider ) {
                        provider.emit('channels:modified', {data: response.data});
                    });

                }
            }
        }
    });
}

/**
 * Channel list provider implementation
 *
 * @constructor
 */
function Provider () {
    Emitter.call(this);
}

/**
 * Start to recursive grab channels
 *
 * @param {object} [config] to grab
 */
function getChannels ( config, callback ) {
    var url = 'tv-channels',
        // add some timestamp to prevent cache request on mag 256
        timestamp = + new Date() /1000;

    config = config || {};


    url += '?limit=' + INIT_CHANNELS_LIMIT;

    if ( config.offset ) {
        url += '&offset=' + config.offset;
    }
    url += '&t=' + timestamp;
    request(url, {
        onload: function ( error, response ) {
            var index;

            if ( error ) {
                // do sth

            } else {
                for ( index = 0; index < response.data.length; index++ ) {
                    tempChannelsData.push(new Channel(response.data[index]));
                }

                if ( !totalChannels ) {
                    totalChannels = response.paging.total;
                }
                // save config and set offset
                if ( tempChannelsData.length < totalChannels ) {
                    config.offset = tempChannelsData.length;
                    getChannels(config, callback);
                } else {
                    // clear tmp data
                    currentChannelList = tempChannelsData;
                    tempChannelsData = [];
                    totalChannels = 0;

                    config.eventName = config.eventName || 'ready';

                    if (config.update) {
                        instanceList.forEach(function ( provider ) {
                            provider.emit('update');
                        });
                    }
                    if ( callback ) {
                        callback(false);
                    }
                    LAST_CHANNELS_ADD = LAST_CHANNELS_DELETE = LAST_CHANNELS_UPDATE = response.timestamp;
                }

            }
        },
        onerror: function () {
            callback(true);
        }
    });
}


Provider.prototype = Object.create(Emitter.prototype);
Provider.prototype.constructor = Provider;

/**
 * Get channel list
 *
 * @param {Object} config to get channels
 * @param {function} callback after getting data
 */
Provider.prototype.getChannels = function ( config, callback ) {
    var result = currentChannelList,
        reg;

    if ( config.favorite ) {
        result = result.filter(function ( channel ) {
            return !!channel.favorite;
        });
    }
    if ( config.genre ) {
        result = result.filter( function ( channel ) {
            return channel.genre.id === config.genre;
        });
    }
    if ( config.byName ) {
        result = result.sort(function ( a, b ) {
            return a.name > b.name ? 1 : -1;
        });
    } else {
        result = result.sort(function ( a, b ) {
            return a.number > b.number ? 1 : -1;
        });
    }

    if ( config.pvr ) {
        result = result.filter( function ( channel ) {
            return ( channel.pvr || channel.local_pvr );
        });
    }

    if ( config.search ) {
        reg = new RegExp(config.search, 'i');
        result = result.filter(function ( channel ) {
            var matchName = channel.name.match(reg),
                matchNumber = channel.number.toString().match(reg);

            return ((matchName && matchName.length) || matchNumber && matchNumber.length);
        });
    }
    callback(false, result);
};

/**
 * Request full update channels list
 *
 * @param {function} callback after all done
 */
Provider.prototype.updateChannelsList = function ( callback ) {
    getChannels(null, callback);
};

Provider.prototype.getCategories = function ( callback ) {
    request('tv-genres', {
        onload: function ( error, response ) {
            if ( error ) {
                if ( callback ) {
                    callback(true);
                }
                return;
            }
            if ( callback ) {
                callback(false, response.data);
            }
        },
        onerror: function () {
            if ( callback ) {
                callback(true);
            }
        }
    });
};

Provider.prototype.getLastChannelId = function ( cb ) {
    request('storage/lastChannel', {
        method: 'GET',
        onload: function ( error, response ) {
            if ( error && cb ) {
                cb(error, null);
            } else if (cb && response.data.value ) {
                cb(false, response.data.value);
            }
        },
        onerror: function () {
            if ( cb ) {
                cb(true, null);
            }
        }
    });
};

Provider.prototype.getEpgLink = function ( config, callback ) {
    var url = 'tv-channels/' + config.channelId + '/epg/' + config.epgId + '/link';

    request(url, {
        onload: function ( error, response ) {
            if ( error ) {
                callback(true, []);
            } else {
                callback(false, response.data);
            }
        },
        onerror: function () {
            callback(true, []);
        }
    });
};


Provider.prototype.getChannelsEpg = function ( config, callback ) {
    var map = {},
        url,
        channelsArray,
        from,
        to,
        params;

    config = config || {};

    channelsArray = config.channels;


    if ( !config.from && !config.to ) {
        params = 'next=1';
    } else {
        from = Math.round(config.from / 1000) || '';
        to  = Math.round(config.to / 1000) || '';
        params = 'from=' + from + '&to=' + to;
    }
    channelsArray.forEach(function ( channel ) { map[channel.id] = channel; });

    url = 'tv-channels/' + encodeURIComponent(channelsArray.map(function ( c ) { return c.id; }).join(',')) + '/epg?' + params;

    return request(url, {
        onload: function ( error, response ) {
            var result = {};

            if ( error && callback ) {
                callback(true, []);
            } else {
                Object.keys(response.data).forEach(function ( prop ) {
                    if ( response.data[prop][0] ) {
                        result[prop] = [];
                        response.data[prop].forEach(function ( epgData ) {
                            epgData.channel = map[prop];
                            result[prop].push( new Epg(epgData));
                        });
                    }
                });
                callback(false, result);
            }
        },
        onerror: function () {
            callback(true, []);
        }
    });
};

// destroy remove this instance from instance list
Provider.prototype.destroy = function () {
    var index = instanceList.indexOf(this);

    if ( index ) {
        instanceList = instanceList.splice(index, 1);
    }
};

function getAppProvider ( config, callback ) {
    var provider = new Provider();


    instanceList.push(provider);

    callback(null, provider);
}

module.exports = getAppProvider;


module.exports.getLauncherProvider = function ( api, ready ) {
    var provider = new Emitter();

    getAppProvider(null, function ( error, appProvider ) {
        if ( error ) {
            console.log('error while try to get provider');
        }

        appProvider.updateChannelsList(function () {

            provider.search = function ( query, doneCallback ) {
                // do smth
                doneCallback(false, []);
            };

            appProvider.getChannels({favorite: true}, function ( error, startData ) {
                ready({
                    provider: provider,
                    data: startData.slice(0, 4).map(function ( channel ) {
                        return {
                            id: channel.id,
                            layout: api.layouts.rectangle,
                            geometry: api.geometry.horizontal,
                            data: {
                                name: channel.name,
                                backgroundImage: core.backend.host + channel.logo,
                                color: '#fff',
                                url:  function ( cb ) {
                                    channel.getUrl(cb);
                                }
                            },
                            actions: []
                        };
                    })
                });
            });
        });
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/js/stalker.js
// module id = 2
// module chunks = 0